import { RadioGroup } from './RadioGroup'
import { RadioInput } from './RadioInput'
import { RadioLegend } from './RadioLegend'

export const Radio = {
  Group: RadioGroup,
  Input: RadioInput,
  Legend: RadioLegend,
}
